import { render, staticRenderFns } from "./CampaignSort.vue?vue&type=template&id=05896a89&scoped=true&"
import script from "./CampaignSort.vue?vue&type=script&lang=js&"
export * from "./CampaignSort.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSort.vue?vue&type=style&index=0&id=05896a89&prod&lang=scss&"
import style1 from "./CampaignSort.vue?vue&type=style&index=1&id=05896a89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05896a89",
  null
  
)

export default component.exports